import { message } from '@rendora/common/composables/message';
import { BottomDrawerFactory } from '@rendora/common/features/bottom-drawer';
import { ModalFactory } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import { useBreakpoint } from '@rendora/design/index';
import type { IResponse } from '~/api/interface';
import AccountLockContent from '../ui/AccountLockContent.vue';

export function useAccountLock(response: IResponse) {
  const { t: $t } = getI18nService();
  const headers = useRequestHeaders();
  const { isMobile } = useBreakpoint(headers?.['user-agent']);
  const { code, msg } = response;
  const resData: any = response.data;
  let inst: any;
  switch (code) {
    case 10003:
      message.error(
        $t(
          'yong-hu-ming-huo-mi-ma-cuo-wu-huan-ke-yi-chang-shi-resdataremainingnum-ci-shi-bai-hou-jiang-suo-ding-10-fen-zhong',
          [resData?.remaining_num],
        ),
      );
      break;
    case 10002:
      if (isMobile.value) {
        inst = BottomDrawerFactory.create({
          content: <AccountLockContent data={resData} i18n={$t} onCancel={() => inst.destroy()} />,
        });
      } else {
        inst = ModalFactory.create({
          title: $t('zhang-hao-yi-suo-ding'),
          content: <AccountLockContent data={resData} i18n={$t} onCancel={() => inst.destroy()} />,
        });
      }
      break;
    default:
      message.error(msg || '');
  }
}
